import { withTheme } from '../config';
import { Input } from '@rneui/base/dist/Input/Input';
export { Input };
export default withTheme(Input, 'Input');
